import { PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICE_NAME, PecGliwiceDataTypeGroupCreateEditFormServiceProvider } from './pec-gliwice-data-type-group-create-edit.service'

export const PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICES_MODULE_NAME = 'simax.services.PecGliwiceDataTypeGroupCreateEditForm'

const KingspanConfigurationFormServicesModule = angular.module(PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICES_MODULE_NAME, [])

KingspanConfigurationFormServicesModule.provider(PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICE_NAME, PecGliwiceDataTypeGroupCreateEditFormServiceProvider)
